import React from 'react';
import styles from './ServiceProviders.module.css'
import image1 from '../../Images/1.png'
import image2 from '../../Images/2.png'
import image3 from '../../Images/3.png'
import image4 from '../../Images/4.png'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { Spinner } from 'react-bootstrap';

const ServiceProvidersForPackage = ({selectedPackageService, header, header2,ServiceStatus,  isEdit, startDateFromEdit,servicesId2, service}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

const onSubmit = (card) =>{


  navigate("/TimeForPackage", {
    state: { details:card,
              servicesCard:selectedPackageService,
              header:header,
              header2:header2,
              ServiceStatus:ServiceStatus,
              isEdit:isEdit,
              startDateFromEdit:startDateFromEdit,
              service:service,
              servicesId2
      } 
  });
}
const Serviceproviders = useSelector((state) => state.ServicesSlice.Serviceproviders);
const isLoading = useSelector((state) => state.ServicesSlice.isLoading);

console.log("Serviceproviders", Serviceproviders)
  return (
    <>
   
  { isLoading ? <div style={{display:"flex", justifyContent:"center"}}>
           
           <Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
          </div>
           :  <div className={styles.cardContainer} >
            { Serviceproviders && Serviceproviders?.length === 0 ?  <div style={{
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  fontSize:"28px",
  fontWeight:"900",
  margin:"70px"
}}>{t('ThereAreNoServiesProducers')} </div>  
  
       : <>
           
      {Serviceproviders && Serviceproviders?.map((card) => (
        <div key={card.empi_num} className={styles.card} onClick={()=>{onSubmit(card)}}>
          {/* <img src={card.emp_img.trim() ? card.emp_img.trim() :image1 } alt={card.emp_namar} className={styles.cardImage} /> */}
          <img src={`https://reservation.ladycaresa.com/public/uploads${card?.emp_img}`} alt={card.emp_namar} className={styles.cardImage} />
          <div className={styles.cardLabel}>
            <span>
            {currentLanguage === "ar"
    ? card.emp_namar.trim() 
    : card.emp_namen.trim() || card.emp_namar.trim() 
  }
            </span>
          </div>
        </div>
      ))}
       </>}
    </div>}
    </>
  );
};

export default ServiceProvidersForPackage;
